export default {
  'pages.login.rememberMe': '自動登錄',
  'pages.login.forgotPassword': '忘記密碼 ?',
  'pages.welcome.alertMessage': '更快更強的重型組件，已經發布。',
  'pages.admin.subPage.title': '這個頁面只有 admin 權限才能查看',
  delete: '刪除',
  edit: '修改',
  cancel: '取消',
  clear: '清除',
  new: '新建',
  update: '更新',
  undo: '復原',
  option: '選項',
  details: '詳情',
  deleting: '刪除中',
  createdAt: '建立時間',
  firstSeen: '首次出現',
  lastActive: '最後活躍',
  'idle.title': '您的工作階段即將過期',
  'idle.content': '立即繼續工作階段或登出',
  resume: '繼續',
  name: '名稱',
  'success.reloading': '成功，正在重新載入頁面',
  'fail.retry': '失敗，請重試',
  tags: '標籤',
  after: '之後',
  flow: '流程',
  text: '文字',
  image: '圖片',
  video: '影片',
  file: '檔案',
  custom: '自訂',
  input: '輸入',
  quickReplies: '快速回覆',
  ctaUrl: 'CTA 連結',
  button: '按鈕',
  question: '問題',
  fieldRequired: '此欄位為必填',
  entity: '實體',
  active: '活躍',
  inactive: '非活躍',
  deleted: '已刪除',
  next: '下一步',
  category: '類別',
  portalUser: '入口網站使用者',
  role: '角色',
  admin: '管理員',
  user: '使用者',
  username: '使用者名稱',
  email: '電子郵件',
  firstName: '名字',
  lastName: '姓氏',
  fullName: '全名',
  resetPassword: '重設密碼',
  'resetPassword.emailSent': '密碼重設郵件已寄送給該使用者',
  'resetPassword.confirm.title': '確定要重設此使用者的密碼嗎？',
  'resetPassword.confirm.content': '密碼重設郵件將寄送至 {username}（{email}）',
  'resetPassword.emailFailed': '傳送重設郵件失敗，請重試',
  'resetPassword.tokenExpired': '重設密碼權杖已過期',
  oldPassword: '目前密碼',
  newPassword: '新密碼',
  'password.characterNotMet': '密碼必須包含至少一個字母、一個數字和一個特殊字元',
  confirmPassword: '確認密碼',
  'confirmPassword.mismatch': '兩次輸入的密碼不一致！',
  unlock: '解鎖',
  'portalUser.unlock.title': '解鎖此使用者',
  'portalUser.unlock.content': '{username}（{email}）－如適用，密碼重設郵件將寄送給該使用者',
  'portalUser.userPasswordModal.title': '使用者密碼視窗',
  logout: '登出',
  dormant: '休眠',
  'portalUser.dormant.title': '確定要將此使用者設為休眠嗎？',
  'portalUser.dormant.content':
    '{username}（{email}）－請注意，設為休眠後，該使用者將無法再存取此入口網站',
  reactivate: '重新啟用',
  'portalUser.reactivate.title': '確定要重新啟用此使用者嗎？',
  'portalUser.reactivate.content':
    '{username}（{email}）－請注意，重新啟用後，該使用者將立即恢復存取此入口網站的權限',
  'portalUser.delete.title': '確定要刪除此使用者嗎？',
  'portalUser.delete.content':
    '{username}（{email}）－請注意，刪除後該使用者將無法再存取此入口網站。個人資料將被清除，您也可以選擇將該使用者設為休眠狀態。',
  'portalUser.delete.undo': '{username}（{email}）已刪除',
  'portalUser.emailChange.title': '變更使用者電子郵件？',
  'portalUser.emailChange.content':
    '電子郵件將更新為 {newEmail}，並會將密碼重設郵件寄送至該地址。該使用者將被登出，必須設定新密碼才能再次登入。',
  'portalUser.emailChange.noEmail.content':
    '電子郵件將更新為 {newEmail}。此機構尚未設定郵件服務，因此系統將產生一組新密碼並顯示給您，以便轉交給該使用者。',
  platform: '平台',
  notes: '備註',
  'pages.review.title': '審閱',
  'pages.review.description': '根據您的問題清單，對一份或多份文件產生結構化審閱',
  'pages.file.placeholder.type': '類型',
  'pages.file.placeholder.people': '建立者',
  'pages.file.placeholder.search': '搜尋檔案或資料夾',
  'pages.file.placeholder.editfile': '修改檔案名稱',
  'pages.file.pdf': 'PDF',
  'pages.file.document': '文件',
  'pages.file.msg': 'MSG',
  'pages.file.eml': 'EML',
  'pages.file.txt': '文字',
  'pages.file.md': 'Markdown',
  'pages.file.excel': 'Excel',
  'pages.file.powerpoint': 'PowerPoint',
  'pages.file.uploading': '上傳中',
  'pages.file.clickDragFile': '點擊或拖曳檔案至此處上傳',
  'pages.file.createfolder': '新增資料夾',
  'pages.file.uploadFiles': '上傳檔案',
  'pages.file.upload.time': '上傳時間：',
  'pages.file.created.time': '建立時間：',
  'pages.file.favorites': '我的收藏',
  'pages.file.history': '修訂歷史',
  'pages.file.success': '建立成功',
  'pages.file.filePreview': '檔案預覽',
  'pages.file.prompt.uploadFiled': '上傳失敗',
  'pages.file.prompt.network': '網路錯誤',
  'pages.file.prompt.fetchFiles': '取得檔案清單資訊失敗',
  'pages.file.prompt.createGroup': '建立群組失敗',
  'pages.file.prompt.createFolderSucc': '資料夾建立成功',
  'pages.file.prompt.createFolderFail': '建立資料夾失敗',
  'pages.file.prompt.updateSucc': '更新成功',
  'pages.file.prompt.updateFail': '更新失敗',
  'pages.file.prompt.addFavoriteFail': '加入失敗',
  'pages.file.prompt.noPermission': '您無權修改此工作階段',
  'pages.file.prompt.duplicateName': '工作階段名稱重複',
  'pages.file.prompt.notFound': '找不到工作階段',
  'pages.file.prompt.deleteGroupSuc': '刪除成功',
  'pages.file.prompt.uploadFiles': '個檔案準備上傳',
  'pages.file.prompt.downloadSucc': '下載成功',
  'pages.file.prompt.downloadFail': '下載失敗',
  'pages.file.prompt.authFail': '缺少授權權杖。',
  'pages.file.prompt.moveSucc': '檔案移動成功',
  'pages.chat.newWithUploadedDocument': '使用文件開始新對話',
  'pages.chat.editSessionName': '修改工作階段名稱',
  'pages.chat.placeholder.inputSessionName': '輸入新的工作階段名稱',
  'pages.chat.placeholder': '輸入您想詢問的內容...',
  'pages.chat.word': '/10000 字元',
  'pages.chat.rateMessage.successfulLike': '成功按讚此訊息',
  'pages.chat.rateMessage.successfulDislike': '成功踩此訊息',
  'pages.chat.actions.like': '回答很好',
  'pages.chat.actions.dislike': '回答不佳',
  'pages.chat.rateMessage.error': '訊息評分失敗',
  'pages.chat.selectContext.setFilePriority.success': '檔案優先順序更新成功',
  'pages.chat.selectContext.setFilePriority.error': '更新檔案優先順序時發生錯誤',
  'pages.chat.selectContext.toolTipDefault': '預設情況下，機器人將可存取您有權存取的所有檔案。',
  'pages.chat.rerank':
    '在傳回結果之前對搜尋結果進行二次排序。這可能會提升結果品質，但會使搜尋速度明顯變慢。',
  'pages.chat.selectContext.tootlTipRestrict': '您可以使用此選單限制模型可使用的檔案。',
  'pages.chat.hybridSearchAlphaTooltip':
    '搜尋比例控制語意搜尋與關鍵字搜尋之間的平衡。數值較低偏向關鍵字搜尋，數值較高偏向語意搜尋。',
  'pages.chat.favoriteFileWeight': '此權重會人為提高收藏檔案的搜尋排名。',
  'pages.dashboard.realTimeUsersTitleTooltip':
    '目前正在與機器人互動，或在過去 5 分鐘內與機器人互動過的使用者數量。',
  'pages.dashboard.activeUsersTitleTooltip': '在所選期間內與機器人互動過的使用者數量。',
  'pages.dashboard.newUsersTitleTooltip': '在所選期間內首次與機器人互動的使用者數量。',
  'pages.dashboard.promptTokensTitleTooltip': '所選期間內處理的輸入權杖數量。',
  'pages.dashboard.completionTokensTitleTooltip': '所選期間內產生的輸出權杖數量。',
  'pages.dashboard.userMessagesTitleTooltip': '所選期間內使用者傳送的訊息數量。',
  'pages.dashboard.storyboardsTitleTooltip': '所選期間內由預建聊天機器人劇本處理的使用者訊息數量。',
  'pages.dashboard.botMessagesTitleTooltip': '所選期間內機器人傳送給使用者的訊息數量。',
  'pages.dashboard.broadcastsTitleTooltip':
    '所選期間內機器人透過廣播功能主動傳送給使用者的訊息數量。',
  'pages.dashboard.repliesTitleTooltip': '所選期間內回覆使用者訊息的數量。',
  'pages.dashboard.messageExchangesTitleTooltip': '所選期間內使用者與機器人交換的訊息數量。',
  'pages.dashboard.broadcastTitleTooltip': '所選期間內機器人發起的廣播數量。',
  'pages.dashboard.outReachTitleTooltip': '所選期間內所有廣播的收件人數總和。',
  'pages.chat.stopGenerating': '已停止產生。',
  'pages.chat.stopGenerating.error': '停止產生失敗。',
  'pages.app.timeline': '時間軸',
  'pages.app.guided_summary': '引導式摘要',
  'pages.app.standard_info': '快速資訊',
  'pages.login.microsoftSSO': '使用 Microsoft 登入',
  'pages.login.loading': '載入中...',
  'pages.login.redirectingToMS': '正在重新導向至 Microsoft SSO...',
  'pages.loggedOut.title': '已登出',
  'pages.loggedOut.heading': '您已登出',
  'pages.loggedOut.description': '您可以關閉此視窗，或返回登入頁面重新登入。',
  'pages.loggedOut.return': '返回登入',
};
